import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { Button } from "@curves/ui-base";
import { UploadBox, UploadFeedbackBox, EmployeeSelect } from '@icoach/components/';
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';
import useNonMemberApi from '@apis/useNonMemberApi';
import { useEmployeeApi } from '@apis/useEmployeeApi';
import { refIsRequiredError, isFunction } from '@util/utils';

const getInitFeedbackData = () => ({
	isShow: false,
	isError: false,
	targetData: {},
});

const ProspectImportDialog = props => {
	const { className, open, refresh, onClose } = props;
	const { postProspectExcelApi } = useNonMemberApi();
	const { getEmployeesOptionsApi } = useEmployeeApi();
	const [feedbackData, setFeedBackData] = useState(getInitFeedbackData());
	const [employeeOptions, setEmployeeOptions] = useState([]);
	const uploadFileRef = useRef(null);
	const employeeRef = useRef(null);

	const doEmployeesOptionsApi = async () => {
		const res = await getEmployeesOptionsApi();
		if (res) setEmployeeOptions(res);
	};

	const doImportApi = async (formData) => {
		const res = await postProspectExcelApi(formData);
		if (res) {
			if (res.isError) {
				const { isError, result } = res;
				setFeedBackData({ isShow: true, isError, targetData: result });
			} else {
				isFunction(refresh) && refresh();
				isFunction(onClose) && onClose();
			}
		}
	};

	const handleFileChange = ({ file }) => {
		if (file) uploadFileRef.current = file;
	};

	const handleSubmit = () => {
		const isError = refIsRequiredError(employeeRef);
		if (!isError) {
			const formData = new FormData();
			if (uploadFileRef.current) {
				const file = uploadFileRef.current;
				formData.append('file', file, file.name);
				doImportApi(formData);
			}
		}
	};

	useEffect(
		() => {
			if (open) {
				setFeedBackData(getInitFeedbackData());
				doEmployeesOptionsApi();
			}
		},
		// eslint-disable-next-line
		[open]
	);

	if (!open) return null;

	return (
		<Dialog className={clsx('simple-content', 'dialog', className)} PaperProps={{ className: 'wx-65rem' }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>名單上傳</GradientColorHeader>
			<DialogContent>
				{!feedbackData.isError
					? <UploadBox onFileChange={handleFileChange} fileExtensions={['xlsx']} />
					: <UploadFeedbackBox isShow={feedbackData.isShow} isError={feedbackData.isError} {...feedbackData.targetData} onCononConfirmfirm={onClose} onDownload={onClose} />
				}
				<EmployeeSelect ref={employeeRef} options={employeeOptions} label="擔當" fullWidth required />
			</DialogContent>
			{!feedbackData.isShow && (
				<DialogActions>
					<Button variant="contained" onClick={handleSubmit}>
						確認匯入
					</Button>
				</DialogActions>
			)}
		</Dialog>
	);
};

export default ProspectImportDialog;
